import React from 'react'
import Lottie from 'react-lottie'

import { compose } from 'recompose'

import {
  AnalyzingContainer,
  AnimationContainer,
  CascadingText,
  DesktopFootnote,
  lottieOptions,
} from 'components/Analyzing'
import EllipsisText from 'components/EllipsisText'
import Layout from 'components/Layout'
import { MobileFootnote } from 'components/MobileFootnote'
import Nav from 'components/Nav'
import { Analyzing as DefaultAnalyzing } from 'pages/SuitabilityQuestions/Analyzing'
import { TestIDs } from 'test/utils/testIds'
import { WithFlowRouterProps, withFlowRouter } from 'utils/FlowProvider'
import { FlowRoute } from 'utils/FlowProvider/types'

const LATER_VALUES = ['Age', 'Income', 'Employment Status']

const enhance = compose<WithFlowRouterProps, {}>(withFlowRouter)

const LaterAnalyzing = enhance(({ route }) => (
  <>
    <Nav />
    <Layout>
      <AnimationContainer data-testid={TestIDs.ANALYZING.LATER_ANIMATION}>
        <Lottie
          isClickToPauseDisabled={true}
          options={lottieOptions}
          eventListeners={[
            {
              eventName: 'complete',
              callback: () => route({ from: FlowRoute.Analyzing, action: 'continue' }),
            },
          ]}
        />
      </AnimationContainer>
      <AnalyzingContainer>
        <EllipsisText text={'Analyzing'} dots={3} />
        <CascadingText values={LATER_VALUES} />
      </AnalyzingContainer>
      <DesktopFootnote>
        Based on your responses we are calculating the right IRA type for you.
      </DesktopFootnote>
    </Layout>
    <MobileFootnote>
      Based on your responses we are calculating a recommended portfolio for you.
    </MobileFootnote>
  </>
))

const Analyzing = ({ flow }) => {
  switch (flow) {
    case 'laterOnboarding':
      return <LaterAnalyzing />
    default:
      return <DefaultAnalyzing />
  }
}

export default enhance(Analyzing)
